import { render } from "./termsModal.vue?vue&type=template&id=8da7078e"
import script from "./termsModal.vue?vue&type=script&lang=js"
export * from "./termsModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__